import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormGroup,
  Grid,
  ButtonGroup,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  clientListTitle: {
    "& h2": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    padding: "0 16px",
    margin: "5px 0 10px 0",
  },
  headerStyle: {
    display: "flex",
    alignItems: "center",
  },
  buttonText: {
    textTransform: "inherit",
    minWidth: "unset",
    "& span:first-child": {
      borderBottom: "1px solid",
      lineHeight: "initial",
    },
  },
}));

function DashboardChartService(props) {
  const {
    currentChartDataArr,
    setCurrentChartDataArr,
    open,
    afterUpdateGraph,
    handleClose,
    grpahChecked,
  } = props;
  console.log(`props`, props);
  const [checked, setChecked] = useState(grpahChecked);
  const classes = useStyles();
  const handleChange = (e) => {
    if (e === "clear") {
      const allValue = {};
      currentChartDataArr.forEach((chartData) => {
        allValue[chartData.name] = false;
        chartData["checked"] = false;
      });
      setChecked(allValue);
      setCurrentChartDataArr(currentChartDataArr);
    } else if (e === "all") {
      const allValue = {};
      currentChartDataArr.forEach((chartData) => {
        allValue[chartData.name] = true;
        chartData["checked"] = true;
      });
      setChecked(allValue);
      setCurrentChartDataArr(currentChartDataArr);
    } else {
      setChecked({
        ...checked,
        [e.target.name]: e.target.checked,
      });
      currentChartDataArr.map(
        (chartData) =>
          chartData.name === e.target.name &&
          (chartData["checked"] = e.target.checked)
      );
      setCurrentChartDataArr(currentChartDataArr);
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      PaperProps={{
        style: {
          minWidth: 640,
          maxHeight: 400,
        },
      }}
    >
      <DialogTitle id="simple-dialog-title" className={classes.clientListTitle}>
        <span>{`${props.assignmentList?"Assignment":"Client"} List`}</span>
        <div className={classes.headerStyle}>
          <div>
            <Button
              disableElevation
              disableRipple
              style={{ paddingRight: "2px" }}
              onClick={() => handleChange("all")}
              color="secondary"
              className={classes.buttonText}
            >
              Select all
            </Button>
            <span style={{ color: "#f28c31" }}> </span>
            <Button
              disableElevation
              disableRipple
              style={{ paddingLeft: "2px" }}
              onClick={() => handleChange("clear")}
              color="secondary"
              className={classes.buttonText}
            >
              Clear
            </Button>
          </div>
        </div>
      </DialogTitle>
      <DialogContent style={{ paddingTop: "0px" }}>
        <Grid container>
          <Grid item xs={12}>
            <List style={{ paddingTop: "0px" }}>
              {currentChartDataArr.length > 0 &&
                currentChartDataArr.map((chartData) => (
                  <ListItem
                    style={{
                      display: "inline-block",
                      width: "calc( 100% / 3 )",
                      padding: 0,
                    }}
                    key={chartData.name + " " + Math.random()}
                  >
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            style={{}}
                            onChange={(e) => handleChange(e)}
                            checked={checked[chartData.name]}
                            name={chartData.name}
                            color="primary"
                          />
                        }
                        label={chartData.name}
                      />
                    </FormGroup>
                  </ListItem>
                ))}
            </List>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disableElevation
          variant="contained"
          style={{ textTransform: "inherit" }}
          onClick={() => {
            afterUpdateGraph(currentChartDataArr, checked);
          }}
          color="primary"
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DashboardChartService;
